export const COLORS = {
  background: "#edf756",
  disabledBtnColor: "#bdbdbd",
  cardHeader: "#e5eaf5",
  cardBackground: "#F8F8F8",
  cardBodyBg: "rgb(230,241,255,1)",
  modalHeader: "red",
  lighterTheme: "#fcf6f5ff",
  darkerTheme: "#89abe3ff",
  transactionComplete: "green",
};
